export default {
  POLLING_INTERVAL: 3000,
  PUBLISHING_INITIATOR_APP_NAME: 'yola-editor',
  YOLA_PARTNER_PUBLISHING_TYPE: 'YOLA',
  FREE_YOLA_SUBDOMAIN: '*.yolasite.com',
};
